import { request } from "../api";
import { ADMIN_ENV, headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { AlertSubscriptionPayload } from "../../../@types/alertSubscriptionManagement";
import {
	AllOpenEnrollmentPayload,
	AllVEBOpenEnrollmentPayload,
	OpenEnrollment,
	SpecificOpenEnrollmentPayload,
	SpecificVEBOpenEnrollmentPayload,
	VerifyBulkOpenEnrollmentPayload
} from "../../../@types/openEnrollment.types";
import { StatusCodes } from "http-status-codes";
import { Member } from "../../../@types/member.types";
import { VEBEnrollment } from "../../../@types/enrollment.types";

const { post, get, put, del, patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member/open-enrollment";

export type EmployeWithOpenEnrollmentQuery = {
	field: string;
	query: string;
	page: string;
	limit: string;
	plan_id: string;
	start_date: string;
	end_date: string;
};

export type EmployeWithVEBOpenEnrollmentQuery = {
	field: string;
	query: string;
	page: string;
	limit: string;
	start_date: string;
	end_date: string;
};

export const getEmployeeWithOpenEnrollmentStartWith = async (
	employeWithOpenEnrollmentQuery: EmployeWithOpenEnrollmentQuery,
	group_number: number
) => {
	try {
		const endpoint = `pages/open-enrollment/starts-with/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			employeWithOpenEnrollmentQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getEmployeeWithVEBOpenEnrollmentStartWith = async (
	employeWithOpenEnrollmentQuery: EmployeWithVEBOpenEnrollmentQuery,
	group_number: number
) => {
	try {
		const endpoint = `pages/open-enrollment/starts-with/VEB/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			employeWithOpenEnrollmentQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const allOpenEnrollment = async (payload: AllOpenEnrollmentPayload) => {
	try {
		const endpoint = `${initialRoute}/all`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return {
					status: true,
					result
				};
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (message === "Open enrollment already done for members") {
				// console.log("err.response", err.response);
				return {
					status: false,
					result: err.response.data.result
				};
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const allVEBOpenEnrollment = async (payload: AllVEBOpenEnrollmentPayload) => {
	try {
		const endpoint = `${initialRoute}/VEB/all`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return {
					status: true,
					result
				};
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (message === "Open enrollment already done for members") {
				// console.log("err.response", err.response);
				return {
					status: false,
					result: err.response.data.result
				};
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const specificOpenEnrollment = async (payload: SpecificOpenEnrollmentPayload) => {
	try {
		const endpoint = `${initialRoute}/specific`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return {
					status: true,
					result
				};
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (message === "Open enrollment already done for members") {
				// console.log("err.response", err.response);
				return {
					status: false,
					result: err.response.data.result
				};
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const specificVEBOpenEnrollment = async (payload: SpecificVEBOpenEnrollmentPayload) => {
	try {
		const endpoint = `${initialRoute}/VEB/specific`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return {
					status: true,
					result
				};
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (message === "Open enrollment already done for members") {
				// console.log("err.response", err.response);
				return {
					status: false,
					result: err.response.data.result,
					errorMessage: message
				};
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const verifyBulkOpenEnrollment = async (payload: VerifyBulkOpenEnrollmentPayload): Promise<Member[]> => {
	try {
		const endpoint = `${initialRoute}/bulk/verify`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: {
						result: { validEmployees }
					}
				} = response;
				return validEmployees;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		// console.log("err", err);
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getOpenEnrollments = async (
	filter: Record<string, unknown>,
	group_number: number
): Promise<OpenEnrollment[]> => {
	try {
		const endpoint = `${initialRoute}/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filter
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};
export const getOpenEnrollmentEmployee = async (
	filter: Record<string, unknown>,
	group_number: number
): Promise<OpenEnrollment[]> => {
	try {
		// // console.log("========filter", filter);
		const endpoint = `${initialRoute}/get-open-enrollment-employee/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filter
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getVEBOpenEnrollmentEmployee = async (
	filter: Record<string, unknown>,
	group_number: number
): Promise<OpenEnrollment[]> => {
	try {
		const endpoint = `${initialRoute}/get-VEB-open-enrollment-employee/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filter
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export type OpenEnrollmentStatusQuery = {
	open_enrollment_id: string;
	group_number: number;
};

export const getOpenEnrollmentStatus = async (
	openEnrollmentStatusQuery: OpenEnrollmentStatusQuery
): Promise<OpenEnrollment[]> => {
	try {
		const endpoint = `${initialRoute}/enrollment-status`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			openEnrollmentStatusQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export type VEBOpenEnrollmentStatusQuery = {
	VEB_open_enrollment_id: string;
	group_number: number;
};

export const getVEBOpenEnrollmentStatus = async (
	VEBOpenEnrollmentStatusQuery: VEBOpenEnrollmentStatusQuery
): Promise<VEBEnrollment[]> => {
	try {
		const endpoint = `${initialRoute}/VEB/enrollment-status`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			VEBOpenEnrollmentStatusQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			alert(err);
		}
		throw err;
	}
};

export const getOpenEnrollmentsForEachEmployee = async (query: any) => {
	try {
		const endpoint = `${initialRoute}/get-open-enrollment-for-each-employee`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};

export const getVEBOpenEnrollmentsForEachEmployee = async (query: any) => {
	try {
		const endpoint = `${initialRoute}/get-veb-open-enrollment-for-each-employee`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			if (ADMIN_ENV == "DEV") {
				console.log(message);
			} else {
				alert(message);
				// alert("Failed to fetch data");
			}
		} else {
			throw error;
		}
	}
};

export const openEnrollment = {
	allOpenEnrollment,
	getEmployeeWithOpenEnrollmentStartWith,
	getEmployeeWithVEBOpenEnrollmentStartWith,
	specificOpenEnrollment,
	verifyBulkOpenEnrollment,
	getOpenEnrollments,
	getOpenEnrollmentEmployee,
	specificVEBOpenEnrollment,
	getOpenEnrollmentStatus,
	allVEBOpenEnrollment,
	getVEBOpenEnrollmentStatus,
	getOpenEnrollmentsForEachEmployee,
	getVEBOpenEnrollmentsForEachEmployee
};
